import React from 'react';
import Component from '@vfuk/core-tag';
const Tag = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default Tag;
